import { useEffect, useState } from 'react';
import { ReactSortable } from 'react-sortablejs';
import Button from '../ui/Button.jsx';
import { Card, CardBody, CardFooter } from '../ui/Card.jsx';
import HeadingOne from '../ui/HeadingOne.jsx';

const Grouping = ({ ...props }) => {
    const { heading, groups, items, button, fn } = props;

    // console.log(items);
    const [dragList, setDragList] = useState(items);
    const [masmediaList, setMasmediaList] = useState([]);
    const [socialmediaList, setSocialmediaList] = useState([]);

    useEffect(() => {
        let originalData = {
            massmedia: masmediaList,
            socialmedia: socialmediaList,
        };

        let cleanedData = {};
        for (const category in originalData) {
            if (Object.hasOwn(originalData, category)) {
                cleanedData[category] = originalData[category].map((item) => {
                    const rest = { ...item };
                    delete rest.chosen;
                    delete rest.selected;
                    return rest;
                });
            }
        }

        fn.handleAction('set:form', cleanedData);
    }, [masmediaList, socialmediaList]);

    return (
        <div className="component-grouping">
            <HeadingOne heading={heading} />

            <Card>
                <CardBody>
                    <div className="row">
                        <div className="col-fluid">
                            <div className="drop-area">
                                <h3 className="drop-title">{groups[0].label}</h3>
                                <ReactSortable
                                    tag="div"
                                    className="drop-container"
                                    list={masmediaList}
                                    setList={setMasmediaList}
                                    group={{
                                        name: groups[0].value,
                                        // pull: ['base'],
                                        // pull: ['components'],
                                        // put: ['components']
                                        pull: true,
                                        put: ['base', 'socialmedia'],
                                    }}
                                >
                                    {masmediaList.map((item) => (
                                        <div className="drop-item" key={item.id}>
                                            {item.label}
                                        </div>
                                    ))}
                                </ReactSortable>
                            </div>
                        </div>
                        <div className="col-fluid">
                            <div className="drop-area">
                                <h3 className="drop-title">{groups[1].label}</h3>
                                <ReactSortable
                                    tag="div"
                                    className="drop-container"
                                    list={socialmediaList}
                                    setList={setSocialmediaList}
                                    group={{
                                        name: groups[1].value,
                                        pull: true,
                                        put: ['base', 'massmedia'],
                                    }}
                                >
                                    {socialmediaList.map((item) => (
                                        <div className="drop-item" key={item.id}>
                                            {item.label}
                                        </div>
                                    ))}
                                </ReactSortable>
                            </div>
                        </div>
                    </div>

                    <div className="drag-area">
                        <ReactSortable
                            key={'base'}
                            tag="div"
                            className="drag-container"
                            list={dragList}
                            setList={setDragList}
                            group={{
                                name: 'base',
                                pull: true,
                                put: true,
                            }}
                            sort={false}
                            animation={150}
                        >
                            {dragList.map((item) => (
                                <div className="drag-item" key={item.id}>
                                    {item.label}
                                </div>
                            ))}
                        </ReactSortable>
                    </div>
                </CardBody>
                <CardFooter>{button && <Button {...button} onClick={() => fn.handleAction(button.action)} />}</CardFooter>
            </Card>
        </div>
    );
};

export default Grouping;
